import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';

/** Navega a faixa nativa criada dentro do overlay, sem escrever estilos. */
@Directive({ selector: '[appCarouselScroll]', standalone: true })
export class CarouselScrollDirective implements AfterViewInit, OnDestroy {
  private selectedIndex = 0;
  private initialized = false;
  private frame?: number;
  private targetIndex?: number;
  @Output() carouselIndexChange = new EventEmitter<number>();

  @Input('appCarouselScroll') set index(value: number) {
    if (value === this.selectedIndex) return;
    this.selectedIndex = value;
    if (this.initialized) this.navigate('smooth');
  }

  constructor(private element: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.initialized = true;
    this.navigate('auto');
  }

  private navigate(behavior: ScrollBehavior): void {
    if (this.frame !== undefined) cancelAnimationFrame(this.frame);
    this.targetIndex = this.selectedIndex;
    this.frame = requestAnimationFrame(() => {
      this.frame = undefined;
      const track = this.element.nativeElement;
      track.scrollTo({ left: this.selectedIndex * track.clientWidth, behavior });
    });
  }

  @HostListener('scroll') onScroll(): void {
    const track = this.element.nativeElement;
    if (this.frame !== undefined || !track.clientWidth) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    if (this.targetIndex !== undefined && index !== this.targetIndex) return;
    if (index !== this.selectedIndex) {
      this.selectedIndex = index;
      this.carouselIndexChange.emit(index);
    }
  }

  @HostListener('scrollend') onScrollEnd(): void {
    this.targetIndex = undefined;
    this.onScroll();
  }

  ngOnDestroy(): void {
    if (this.frame !== undefined) cancelAnimationFrame(this.frame);
  }
}
